export const supportedLocales = [
  'en-AU',
  'en-CA',
  'en-GB',
  'en-US'
];
